module.exports = __webpack_public_path__ + "img/Honda.9f393c40.png";